import { render } from "./invoice-details.vue?vue&type=template&id=6792961c&scoped=true"
import script from "./invoice-details.vue?vue&type=script&lang=js"
export * from "./invoice-details.vue?vue&type=script&lang=js"

import "./invoice-details.vue?vue&type=style&index=0&id=6792961c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6792961c"]])

export default __exports__